import { render } from "./AppointmentPrice.vue?vue&type=template&id=48946875&ts=true"
import script from "./AppointmentPrice.vue?vue&type=script&lang=ts"
export * from "./AppointmentPrice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__